import { scrollToSectionId } from "./scrollToSection";

/**
 * Navegação por âncora compatível com React Router (SPA).
 */
function closeMobileMenuIfOpen() {
  const collapse = document.getElementById("bs-example-navbar-collapse-1");
  if (!collapse) return;

  // Bootstrap 3 usa a classe "in" para estado aberto.
  const isOpen = collapse.classList.contains("in");
  if (!isOpen) return;

  collapse.classList.remove("in");
  collapse.setAttribute("aria-expanded", "false");

  const toggleBtn = document.querySelector("#menu .navbar-toggle");
  if (toggleBtn) {
    toggleBtn.classList.add("collapsed");
    toggleBtn.setAttribute("aria-expanded", "false");
  }
}

export function navigateToSection(navigate, location, sectionId) {
  const targetHash = `#${sectionId}`;
  closeMobileMenuIfOpen();

  if (location.pathname !== "/") {
    navigate({ pathname: "/", hash: targetHash });
    // aguarda troca de rota e garante tentativas extras
    window.setTimeout(() => scrollToSectionId(sectionId), 120);
    window.setTimeout(() => scrollToSectionId(sectionId), 260);
    window.setTimeout(() => scrollToSectionId(sectionId), 420);
    return;
  }

  // Na home, faz scroll imediato para a seção.
  scrollToSectionId(sectionId);
  window.setTimeout(() => scrollToSectionId(sectionId), 120);
  window.setTimeout(() => scrollToSectionId(sectionId), 260);

  // Mantém hash sincronizado para permitir deep-link.
  if (window.location.hash !== targetHash) {
    window.history.replaceState(null, "", `/${targetHash}`);
  }
}

/** href no formato "/#id" — retorna o id ou null */
export function parseHashSectionHref(href) {
  if (!href || typeof href !== "string") return null;
  if (!href.startsWith("/#")) return null;
  const id = href.slice(2);
  return id || null;
}
